import Column from '@components/Column';
import Radio from '@components/Radio';
import Text from '@components/Text';
import styled from '@emotion/styled';
import { OrderType } from '@models/order';
import useCalculatedRequest from '@store/order/hooks/useCalculatedRequest';
import { orderActions } from '@store/order/orderSlice';
import { useDispatch } from 'react-redux';

function OrderTypeSelector() {
  const { orderType } = useCalculatedRequest();
  const dispatch = useDispatch();
  const updateOrderType = (ot: OrderType) => {
    dispatch(orderActions.setOrderType(ot));
  };
  return (
        <Container>
            <Text fontWeight='bold' size='lg'>주문 방식</Text>
            <Column spacing={8}>
                <Radio value='TAKE_OUT' isSelected={orderType === 'TAKE_OUT'}
                       onChange={() => updateOrderType('TAKE_OUT')}>
                    테이크 아웃
                </Radio>
                <Radio value='IN_SHOP' isSelected={orderType === 'IN_SHOP'}
                       onChange={() => updateOrderType('IN_SHOP')}>
                    매장 식사
                </Radio>
            </Column>
        </Container>
  );
}

const Container = styled.div`
    padding: 20px 20px 0;
    display: flex;
    flex-direction: column;
    row-gap: 12px;
`;

export default OrderTypeSelector;
